import Header from 'layouts/HomeHeader';
import Form from './form';

const Seller = () => {
  return (
    <>
      <Header />
      <Form />
    </>
  );
};

export default Seller;
